export default function mergeEntities(bag = {}, entities = {}) {
	const newBag = { ...bag };

	Object.keys(entities).forEach((id) => {
		newBag[id] = {
			...newBag[id],
			...entities[id]
		};
	});

	return newBag;
}

export function mergeFacilities(bag = {}, facilities = {}) {
	const newBag = { ...bag };

	Object.keys(facilities).forEach((id) => {
		const existingFacility = newBag[id];
		const newFacility = facilities[id];

		const mergedFacility = {
			...existingFacility,
			...newFacility
		};

		// If existing facility has reviews, preserve them and don't override
		if (existingFacility && existingFacility.reviews) {
			mergedFacility.reviews = existingFacility.reviews;
		}

		// Always use the new units array when present - concatenation causes stale
		// units to persist when filters change (selector takes first 3, so old units
		// would always display instead of newly filtered results)
		if (Array.isArray(newFacility.units)) {
			mergedFacility.units = newFacility.units;
		}


		newBag[id] = mergedFacility;
	});

	return newBag;
}
